const CONSUMER_TRACKING_VALUE = {
  userStatusLoggedIn: 'logged in',
  userStatusLoggedOut: 'logged out',
  actionSource: 'web',
  siteType: 'consumer web',
} as const;

export { CONSUMER_TRACKING_VALUE };
